import * as types from '../constants/ActionTypes';

export const setStatusLayout = (statusLayout) => ({
  statusLayout,
  type: types.SET_STATUS_LAYOUT,
});
